export const roundToInteger = (n: number) => Math.round(n);
export const roundToCents = (n: number) => +`${Math.round(+`${n}e+2`)}e-2`;

export const limitPossitive = (n: number) => isFinite(n) ? Math.max(n, 0) : 0;
export const limitPercentage = (n: number) => isFinite(n) ? Math.min(Math.max(n, 0), 100) : 0;

export const compareToCents = (nA: number, nB: number) => roundToCents(nA) === roundToCents(nB);
